import { Component,ElementRef, HostListener, OnInit ,Input} from '@angular/core';
import { CommonService } from 'src/modules/shared/services/common.service';
import { TranslateService } from '@ngx-translate/core';
import { browser } from 'protractor';
import { NavigationExtras, Router } from '@angular/router';
import { UserConfigService } from 'src/modules/shared/services/userConfig.service';
import { DataSharingService } from 'src/modules/shared/services/DataSharing.service';
import { RequestType } from 'src/modules/shared/enums/request-type';
import { ApplicantManagementService } from 'src/modules/profile-management/services/applicant-management-service.service';
import { LoaderService } from 'src/modules/shared/services/loader.service';
import { LoginService } from 'src/modules/login/services/login.service';

declare var $: any;
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  isLanguageDefault: boolean;
  // currentLang = 'ar';
  userId: string = "";
  userType: string = "";
  language: string;
  isLoggedIn: boolean;
  username: string = "";
  isCollapsed :boolean =false;


 // updates
  currentUser : any;
  profileButtonTitle: string;

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (this.eRef.nativeElement.contains(event.target)) {
      // inside component 
      this.isCollapsed = false;
    } else {
      // outside component
      this.isCollapsed = true;
    
    }
  }
  closeMainMenu(){
    $('.navbar-collapse').collapse('hide');
  }

  constructor(private loginService: LoginService, public translate: TranslateService, private router: Router, private userConfig: UserConfigService, private eRef: ElementRef, private dataSharingService:DataSharingService) {
    // this.currentLang = localStorage.getItem('lang') || this.currentLang;
    translate.addLangs(['en', 'ar']);
    translate.setDefaultLang('en');

    this.dataSharingService.isUserLoggedIn.subscribe( value => {
      this.isLoggedIn = value;
    });
  
    this.dataSharingService.userName.subscribe(value => {
      this.username = value;
    });

     // get current user data
     this.currentUser = {
      userLang: this.translate.currentLang,
      userType: this.userConfig.getUserType()
    }
  }
 
  Login(){
    this.loginService.RedirectToLogin();
  }

  ngOnInit() {
    //if (this.currentLang == 'en')
    //  this.isLanguageDefault = false;
    //else
    //this.isLanguageDefault = true;
    if (this.translate.currentLang == 'en')
      this.isLanguageDefault = false;
    else
      this.isLanguageDefault = true;
    if (localStorage.getItem('lang') === "ar") {
      this.language = "ar";
    }
    else {
      this.language = "en";
    }
    localStorage.getItem('lang') === 'ar' ? this.translate.use('ar') : this.translate.use('en');



    ////////////////////////////
    //////////// Check Auth

    // this.userConfig.loggedinCast.subscribe(_isloggedIn => this.isLoggedIn = _isloggedIn ?_isloggedIn: this.userConfig.isLoggedIn());    // if (this.userConfig.getUserName()) {
    //   console.log(this.isLoggedIn);
    //   this.username = this.userConfig.getUserName();
    // }
    // else {
    //   this.username="User";
    // }
    // this.isLoggedIn = true;
    // let userName=this.language=="en"?sessionStorage.getItem("EnglishUserName"):sessionStorage.getItem("ArabicUserName");
    // console.log(userName);
    // this.userConfig.cast.subscribe(_userName => this.username = _userName ?_userName: userName);
    // console.log(this.username);
  
  }
  changelang(lang, e) {
    // e.preventDefault();
    
    var value = localStorage.getItem('lang');
    if (lang == value) {
      return false;
    }
    lang === 'ar' ? localStorage.setItem('lang', 'ar') : localStorage.setItem('lang', 'en');
    // this.commonservice.storeAngularState(history.state);
    window.location.reload();
    this.language=lang;
  }
  logOut() {
    // location.reload();
    this.username = "";
    this.isLoggedIn = false;
    // localStorage.clear();
    sessionStorage.clear();
    window.location.href ="/home"
    // this.router.navigateByUrl('/login');
    // this.router.navigate(['/login']);
  }
  closeMenu() {
    let displayMenu = this.isCollapsed ? true : false;
    return displayMenu;
  }


  // updates
  // RouteToMyProfile(){
  //   if (this.userConfig.getUserType() === RequestType.IndividualRequest.toString()) {
  //     this.router.navigate(['/profile/details']);
  //   } else if (this.userConfig.getUserType() === RequestType.CompanyRequest.toString()) {
  //     this.router.navigate(['/profile/applicants/details']);
  //   }
  // }
  RouteToChangeLogin(){
    this.router.navigate(['/login'], {state: {isChangeLogin: true}});
  }
  IsUserCompany():boolean{
    return this.userConfig.getUserType() === RequestType.CompanyRequest.toString() ? true: false;
  }

}
